import React from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { IInput, ILabel } from '../../../../../utils/types/contentful';
import { NoozLetterForm } from '../../../../Admin/Prospect/Noozletter/noozletter';
import { Link } from '../../../Elements/Link';

export interface FooterNoozletter {
  label: ILabel;
  subLabel: ILabel;
  input: IInput;
}

export const FooterNoozletter = ({
  label,
  subLabel,
  form,
  cookieLink,
}: FooterNoozletter) => (
  <>
    <div className='mb-2'>
      <Label
        {...label}
        type='h3'
        color={{ classname: 'white' }}
        weight='bold'
        size='2xl'
      />
      <div className='mt-4'>
        <Label
          {...subLabel}
          color={{ classname: 'white' }}
          size='lg'
          weight='normal'
        />
      </div>
    </div>
    <NoozLetterForm
      {...form}
      form={{
        ...form,
        submitButton: {
          ...form.submitButton,
          icon: {
            iconKey: 'HiChevronRight',
            size: 'lg',
            color: { classname: 'sun' },
          },
          color: { classname: 'white' },
          type: 'contained',
          size: 'lg',
        },
      }}
    />
    {cookieLink && (
      <div className='mt-3'>
        <Link
          {...cookieLink}
          label={{
            ...cookieLink?.label,
            color: { classname: 'white' },
            size: 'sm',
            decoration: 'underline',
          }}
        />
      </div>
    )}
  </>
);
